export default "__VITE_ASSET__BnUA94B7__"